import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SEU_SVG_NOT_FOUND } from '@seu-helpers';
import { StoreService } from '@seu-services';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'seuConfigSvg',
  standalone: true,
})
export class SeuConfigSvgPipe implements PipeTransform {
  constructor(
    private store: StoreService,
    private sanitizer: DomSanitizer
  ) {}

  public transform(key: string): SafeHtml {
    const svgs = this.store.getConfig()?.svgs;
    const notFoundSvg = SEU_SVG_NOT_FOUND;
    if (!svgs) {
      return this.sanitizer.bypassSecurityTrustHtml(notFoundSvg);
    }

    let svg = svgs[key];
    if (!svg) {
      svg = svgs[key.toLowerCase()];
    }

    return this.sanitizer.bypassSecurityTrustHtml(svg ?? notFoundSvg);
  }
}
